//
import ExtendModel from "@/models/ExtendModel"

/**
 * @class
 */
export default class GUser extends ExtendModel {

    //
    static includes = [
        "hr_employee",
    ]

    /**
     * @description
     * 
     */
    get full_name () {
        return this.hr_employee ? [ this.hr_employee.names, this.hr_employee.last_name1, this.hr_employee.last_name2 ].join( " " ) : "-"
    }

    /**
     * 
     */
    resource () {
        return "g_user"
    }
}